import { vmRefProcessorApp } from '../../../global-utils';
import { loadSingleModules } from '../../../global-utils/loadModules';
import {
  APP_MOBILE_MENU_OPEN,
  APP_MOBILE_MENU_CLOSE,
  APP_MOBILE_MENU_TOGGLE,
  APP_TOPNAV_MENU_OPEN,
  APP_TOPNAV_MENU_CLOSE,
  APP_SET_READY,
  APP_SET_READY_ERROR,
  APP_SET_CORE,
  APP_CHANGE_PAGE,
  APP_CHANGE_BREAKPOINT,
  SET_CURRENT_LOCATION,
  SET_TEST_FLIGHT_PAGE,
  SET_TEST_FLIGHT_PAGE_PARAMS,
  SET_TEST_FLIGHT_COMPONENTS_BUILDING,
  SET_GRID_WITH_SIDE_PREVIEW,
  SET_CLIENT_DATA,
  MANUAL_UPDATE_CLIENT_DATA,
  USER_AUTH_LOADING_START,
  USER_AUTH_LOADING_END,
  SET_USER_IS_ONLINE,
  SET_USER_IS_OFFLINE,
  SET_MY_NETWORKING,
  FORCE_CLOSE_SPLASH_SCREEN,
  SET_LAYER,
  SET_VOUCHER,
  SET_FRESH_CHAT_READY,
  SET_ADMIN_CLIENT_PREVIEW,
  ENABLE_SCREEN_SAVER,
  DISABLE_SCREEN_SAVER
} from '../constants';
import { apiRequest } from '../../../global-utils/api-request';
import { loginUser } from '.';
import storageAndCookie from '../../../global-utils/storage-and-cookies';
import { isArr, isObjKey } from '../../../global-utils/globalUtils';
import { getIsAdminPreview } from '../../../shared/admin-preview';
import manage from '../../../shared/m-anage';
import { emptyNull, hardReloadApp, identity } from '../../../shared/misc';
import { loginInfoToStorage } from './utils';
import { fetchCore, fetchAppConfig } from '../../../features/boot';

export const setAppOnline = () => ({ type: SET_USER_IS_ONLINE });
export const setAppOffline = () => ({ type: SET_USER_IS_OFFLINE });

export const setAppVoucher = (voucher) => ({ type: SET_VOUCHER, payload: voucher });
export const setCurrentAppLocation = (loc) => ({
  type: SET_CURRENT_LOCATION,
  payload: loc
});
export const openMobileMenu = () => ({
  type: APP_MOBILE_MENU_OPEN,
  payload: {}
});
export const closeMobileMenu = () => ({
  type: APP_MOBILE_MENU_CLOSE,
  payload: {}
});
export const toggleMobileMenu = () => ({
  type: APP_MOBILE_MENU_TOGGLE,
  payload: {}
});
export const openTopNavMenu = (topNavMenuAnchor) => ({
  type: APP_TOPNAV_MENU_OPEN,
  payload: { topNavMenuAnchor }
});
export const closeTopNavMenu = () => ({
  type: APP_TOPNAV_MENU_CLOSE,
  payload: {}
});

export const setAppReady = (settings) => (dispatch) => {
  const moduleList = Object.values(settings.modules ?? emptyNull)
    .filter((el) => el.isActive);

  manage.configure(settings.modules?.manageConfig?.settings);

  // First - load modules on page load only needed on page load
  moduleList.forEach((el) => loadSingleModules(el, false));
  const allCompsToCore = moduleList
    .flatMap((el) => el.componentsToCore)
    .filter(identity);

  // Reference library is packed in the settings.
  // Resolving references within vmRefLib is taken care
  // of inside the updateDefinition function. This is why
  // we destruct it and pass only restSettings into the
  // resolve function.
  const { vmRefLib, ...restSettings } = settings;
  const settingsVmRefResolved = vmRefProcessorApp
    .updateDefinitions(vmRefLib)
    .resolve(restSettings);

  // Place reference-resolved settings into redux
  dispatch({
    type: APP_SET_READY,
    payload: { settings: settingsVmRefResolved, isReady: true, allCompsToCore }
  });
};

export const setPagePreview = (settings) => ({
  type: SET_TEST_FLIGHT_PAGE,
  payload: settings
});
export const setPageParams = (pageParams) => ({
  type: SET_TEST_FLIGHT_PAGE_PARAMS,
  payload: pageParams
});
export const setComponentsBuildingPreview = (settings) => ({
  type: SET_TEST_FLIGHT_COMPONENTS_BUILDING,
  payload: settings
});
export const setAppReadyError = (isReady) => ({
  type: APP_SET_READY_ERROR,
  payload: isReady
});
export const setCoreData = (coreData) => ({
  type: APP_SET_CORE,
  payload: coreData
});

export const changeCurrentPageInfo = (title, pageName) => ({
  type: APP_CHANGE_PAGE,
  payload: { title, pageName }
});

export const changeCurrentBreakpoint = (breakpoint) => ({
  type: APP_CHANGE_BREAKPOINT,
  payload: breakpoint
});

export const setGridWithSidePreview = (isActive, content) => ({
  type: SET_GRID_WITH_SIDE_PREVIEW,
  payload: { isActive, content }
});

export const prepareApp = () => (dispatch) => {
  // in preview, all info is passed through messages.
  if (getIsAdminPreview()) return;

  fetchCore()
    .then(fetchAppConfig)
    .then(({ coreSettings, appConfig }) => {
      dispatch(setCoreData(coreSettings));
      dispatch(setAppReady(appConfig));
    })
    .catch((error) => {
      console.error('VM ERROR: cannot fetch app data.', { cause: error });
      dispatch(setAppReadyError(false));
    });
};

export const ocaLogin = ({ uid, accessToken }) => (dispatch, getState) => {
  const state = getState();
  const { instance } = state.appState.settings?.modules?.loginToJMTModule?.settings ?? {};

  const instanceUser = `${instance}.user`;

  const url = `https://${state?.appState?.core.server_addr}/v1/logins/${uid}.json`;
  const body = {
    access_token: accessToken,
    include_user: 1,
    include_grants: 1,
    include_manage_jwt_token: 1
  };
  apiRequest({ url, body })
    .then((res) => {
      if (!res?.data?.error_code && !res?.data?.error_message) {
        dispatch(loginUser(res.data));
        // Keep user info in cookies:
        if (res.data.manage_jwt_token) {
          storageAndCookie.set(
            instanceUser,
            JSON.stringify({ accessToken: res.data.manage_jwt_token })
          );
        }
        loginInfoToStorage(res.data);
        hardReloadApp();
      }
    })
    .catch((err) => console.error('ocaLogin err ', err));
};

// clientData
export const setClientData = (key, value) => (dispatch) => {
  if (isObjKey(key)) {
    dispatch({ type: SET_CLIENT_DATA, payload: { key, data: value } });
  } else {
    console.error(`VM2: cannot set value ${value} to key:${key} - wrong key`);
  }
};

export const deleteClientData = (keyList) => (dispatch, getState) => {
  if (!isArr(keyList)) return;

  const clientDataNew = keyList.reduce((acc, key) => {
    const { [key]: unused, ...restClientData } = acc;
    return restClientData;
  }, getState().appState.clientData ?? {});

  dispatch({ type: MANUAL_UPDATE_CLIENT_DATA, payload: clientDataNew });
};

export const appendToClientData = (key, data) => (dispatch, getState) => {
  if (isObjKey(key)) {
    const clientDataVal = getState().appState.clientData?.[key] ?? [];
    dispatch(setClientData(key, [...clientDataVal, ...data]));
  } else {
    console.error(`VM2: cannot delete clientData at key:${key} - wrong key`);
  }
};

export const userAuthLoadingStart = () => ({
  type: USER_AUTH_LOADING_START
});

export const userAuthLoadingEnd = () => ({
  type: USER_AUTH_LOADING_END
});

export const setMyNetworking = (key, val) => (dispatch, getState) => {
  const { myNetworking = {} } = getState().appState ?? {};
  const myNetworkingNew = {
    ...myNetworking,
    [key]: val
  };
  dispatch({ type: SET_MY_NETWORKING, payload: myNetworkingNew });
};

export const forceCloseSplashScreen = () => ({
  type: FORCE_CLOSE_SPLASH_SCREEN
});

export const setLayer = (val) => ({ type: SET_LAYER, payload: val });
export const layerHandleContent = (type) => ({ type }); // Lock/Unlock content

export const setFreshChatReady = () => ({ type: SET_FRESH_CHAT_READY });
export const setIsAdminClientPreview = (val) => ({ type: SET_ADMIN_CLIENT_PREVIEW, payload: val });
export const enableScreenSaver = () => ({ type: ENABLE_SCREEN_SAVER });
export const disableScreenSaver = () => ({ type: DISABLE_SCREEN_SAVER });
